import React from 'react';
import { FormattedMessage } from 'react-intl';

import { NOTIFICATION_TYPE_ERROR, NOTIFICATION_TYPE_INFO, NOTIFICATION_TYPE_SUCCESS } from 'ui-components/services/notification-service';

import { AU, CA, FR, GB } from '../../../../constants/country-codes';
import { messages } from '../messages';

const INFO = {
  title: <FormattedMessage {...messages.processingNotificationTitle} />,
  notificationType: NOTIFICATION_TYPE_INFO,
  getContent: (taxIdName) => <FormattedMessage {...messages.processingNotificationDescription} values={{ taxIdName }} />,
};

const SUCCESS = {
  title: <FormattedMessage {...messages.successNotificationTitle} />,
  notificationType: NOTIFICATION_TYPE_SUCCESS,
  getContent: (taxIdName) => <FormattedMessage {...messages.successNotificationDescription} values={{ taxIdName }} />,
};

const VALIDATION_ERROR = {
  title: <FormattedMessage {...messages.validationErrorNotificationTitle} />,
  notificationType: NOTIFICATION_TYPE_ERROR,
  getContent: (taxIdName) => <FormattedMessage {...messages.validationErrorNotificationDescription} values={{ taxIdName }} />,
};

export const TAX_IDENTIFIER_NOTIFICATION = {
  INFO,
  SUCCESS,
  VALIDATION_ERROR,
};

export const TaxError = {
  InvalidForm: 'invalidForm',
};

export const TAX_IDENTIFIER_FIELD = 'taxIdentifier';

export const TaxIdentifierName = {
  [AU]: 'ABN',
  [CA]: 'GST/HST',
  [FR]: 'VAT ID',
  [GB]: 'VAT ID',
};

export const defaultTaxIdentifierName = 'VAT ID';

export const TaxIdCountryConfig = {
  AU: {
    regex: '^\\d{11}$',
    mask: '99999999999',
  },
  CA: {
    regex: '^\\d{9}RT\\d{4}$',
    mask: '999999999RT9999',
    keepMaskCharacters: true,
  },
  GB: {
    regex: '^\\d{9}$',
    mask: 'GB999999999',
  },
  FR: {
    regex: '^\\d{11}$',
    mask: '99999999999',
  },
  DE: {
    regex: '^\\d{9}$',
    mask: '999999999',
  },
  IT: {
    regex: '^\\d{11}$',
    mask: '99999999999',
  },
  NL: {
    regex: '^\\d{9}B\\d{2}$',
    mask: '999999999999',
  },
  BE: {
    regex: '^[01]\\d{9}$',
    mask: 'BE9999999999',
  },
  LU: {
    regex: '^\\d{8}$',
    mask: '99999999',
  },
  PT: {
    regex: '^\\d{9}$',
    mask: '999999999',
  },
  HU: {
    regex: '^\\d{8}$',
    mask: '99999999',
  },
  AT: {
    regex: '^U\\d{8}$',
    mask: '999999999',
  },
  ES: {
    regex: '^[A-Z]\\d{8}$|^\\d{8}[A-Z]$|^[A-Z]\\d{7}[A-Z]$',
    mask: '999999999',
  },
  IE: {
    regex: '^\\d{7}[A-Z]{1,2}$|^\\d[A-Z]\\d{5}[A-Z]$|^\\d{8}[A-Z]$|^\\d{7}[A-Z]\\d$|^\\d{6}[A-Z]{2}$',
    mask: '999999999',
    hideMask: true,
  },
};
